import React, { useState } from 'react'
import { Button } from 'antd'
import EditFileGradingModal from './EditFileGradingModal'
import { useSelector } from 'react-redux'

const EditFileGradingButton = () => {
    const drawer = useSelector(state => state.assignment.drawer)

    const [showEditFileGradingModal, setShowEditFileGradingModal] = useState(false)

    const handleEditFileGradingClick = () => setShowEditFileGradingModal(true)

    return (
        <>
            <Button onClick={handleEditFileGradingClick}>Edit File Grading</Button>
            {showEditFileGradingModal && (
                <EditFileGradingModal
                    showEditFileGradingModal={showEditFileGradingModal}
                    setShowEditFileGradingModal={setShowEditFileGradingModal}
                    file={{
                        id: drawer?.file?.id,
                        grade: drawer?.file?.file_grade,
                        feedback: drawer?.file?.feedback,
                    }}
                />
            )}
        </>
    )
}

export default EditFileGradingButton
